import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'
import { useAuthStore } from './stores/authStore'
import { useConfigStore } from './stores/configStore'
import { useLanguage } from './composables/useLanguage'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/pages/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

// Inizializza lo stato dell'autenticazione prima di montare l'app
const authStore = useAuthStore()
authStore.initializeFromSessionStorage()

// Inizializza la configurazione (Countdown Mode)
const configStore = useConfigStore()
configStore.startStatusPolling()

// Avviamo il caricamento dello stato (configurazione e auth silente) prima di montare l'app
configStore.fetchStoreStatus().then(() => {
  // Se siamo in modalità countdown, non tentiamo l'autenticazione silente
  if (!configStore.isCountdownMode) {
    return authStore.checkAuth()
  }
}).then(() => {
  // Inizializza il sistema di localizzazione minimale
  const { t } = useLanguage()
  app.config.globalProperties.$t = t

  app.use(router)
  app.mount('#app')
})
